import { motion, useSpring } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, className, delay = 0, y = 26, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Magnetic({ children, strength = 0.28 }) {
  const x = useSpring(0, { stiffness: 170, damping: 14 });
  const y = useSpring(0, { stiffness: 170, damping: 14 });
  return (
    <motion.span
      className="magnetic"
      style={{ x, y }}
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        x.set((e.clientX - (r.left + r.width / 2)) * strength);
        y.set((e.clientY - (r.top + r.height / 2)) * strength);
      }}
      onMouseLeave={() => {
        x.set(0);
        y.set(0);
      }}
    >
      {children}
    </motion.span>
  );
}
